import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../common/types';
import { useMusicVideoEditor } from '../MusicVideoEditorContext';
import { timelineMessages } from '../messages/timelineMessages';
import { barAndBeat, formatTime, secToPercent, type TimelineView } from './timelineGeometry';
import styles from './TimelineGuide.module.scss';

/** The place of a drag or a drop, and whether it snapped (design c5: the pink line and its tag). */
export interface DragGuide {
  sec: number;
  free: boolean;
}

/** The pink snap line and its tag "Snaps to bar 27, beat 1 · 0:52.9" (design c5). */
const TimelineGuideComponent: React.FC<{ guide: DragGuide; view: TimelineView }> = ({ guide, view }) => {
  const intl = useIntl();
  const { songMap } = useMusicVideoEditor();
  const left = secToPercent(guide.sec, view);
  if (left < 0 || left > 100) {
    return null;
  }
  const time = formatTime(guide.sec, true);
  const place = guide.free ? null : barAndBeat(guide.sec, songMap.beats, songMap.downbeats);
  return (
    <>
      <div className={styles.snapLine} style={{ left: `${left}%` }} />
      <div className={styles.dragTip} style={{ left: `calc(${left}% + 6px)` }} role="status">
        {place === null
          ? intl.formatMessage(timelineMessages.freeTip, { time })
          : intl.formatMessage(timelineMessages.snapTip, { bar: place.bar, beat: place.beat, time })}
      </div>
    </>
  );
};

export const TimelineGuide = TypedMemo(TimelineGuideComponent);
